<script lang="ts">
	import OptionsMenu from '../OptionsMenu/OptionsMenu.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import PostedBy from '$lib/components/PostedBy/PostedBy.svelte';
	import {
		getOptionsMenuPerms,
		type PostHeaderParent,
	} from '$lib/components/Post/OptionsMenu/getOptionsMenuPerms';
	import { getPostContextStore } from '$lib/components/Post/postContextStore';
	import type { PostStatus } from '$lib/api/restApi';

	const post = getPostContextStore();

	const { hub, user } = getHubStores();
	export let postIndex: number | undefined = undefined;
	export let parent: PostHeaderParent;

	let { renderOptionsMenu, permissions } = getOptionsMenuPerms({
		type: parent,
		perms: $hub.user_context.perms.posts,
		status: $post.status as PostStatus,
		user: $user,
		post: $post,
	});

	permissions = {
		...permissions,
		pin: parent == 'collectionPage', // pinning should not be allowed if its rendered in post detail page (/posts/{postSlug}) or manage content post detail page (/content/{postId})
	};
</script>

<header>
	<PostedBy
		user={$post.user}
		time={$post.published_at}
		collection={$post.collection}
		user_role={$post.user_role}
		withPopover={$hub.user_context.perms.team.open_user_popup} />

	{#if renderOptionsMenu}
		<OptionsMenu {postIndex} {permissions} {parent} />
	{/if}
</header>

<style>
	header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: var(--gutterMedium);
	}
</style>
